import type { Role } from "../api/types.ts"

/**
 * 지금 보고 있는 화면에 맞는 매뉴얼 문서.
 *
 * 화면마다 "도움말"이 서로 다른 곳을 가리켜야 쓸모가 있다 — 입고 스캔에서 누른 도움말이
 * 목차 첫 장을 열면 아무도 다시 누르지 않는다.
 *
 * 같은 화면이라도 역할에 따라 할 일이 다르면 다른 문서로 보낸다. 반품 상세에서
 * 쿨트랙JP가 할 일은 검수이고, 화주가 할 일은 입고 확인과 처리방안이다.
 */
export function helpSlugFor(pathname: string, role: Role): string | null {
  // 매뉴얼 안에서는 도움말을 또 걸지 않는다.
  if (pathname.startsWith("/manual")) return null

  const isWarehouse = role === "warehouse"

  if (pathname === "/") return "screen"
  if (pathname === "/cases") return "cases-list"
  if (pathname === "/cases/new") return "intake"
  if (/^\/cases\/\d+$/.test(pathname)) return isWarehouse ? "inspect" : "arrival-check"
  if (pathname === "/scan") return "scan"
  // 무적화물은 입고 스캔 업무의 일부다 — 설명도 그 문서 한 곳에 둔다.
  if (pathname === "/orphans") return "scan"
  if (pathname === "/shipments") return "shipment"
  if (/^\/shipments\/\d+$/.test(pathname)) return isWarehouse ? "shipment" : "kr-arrival"
  if (pathname === "/item-masters") return "item-masters"
  if (pathname.startsWith("/settings")) return "account"

  return null
}
